import { FC } from 'react';
import { Heading, Icon, Text, Tooltip } from '@livechat/design-system-react-components';
import { Info } from '@livechat/design-system-icons';

import { Layout } from 'components/layout/Layout';

import * as styles from './styles';

type Props = {
  email: string;
};

export const ResetPasswordSent: FC<Props> = ({ email }) => (
  <Layout showHeaderLogo showGoToSignIn>
    <div css={styles.container} data-testid="reset-password-result">
      <Heading css={styles.textHeader}>Help is on the way!</Heading>
      <Text css={styles.text}>
        If you&apos;re using email and password for login, we sent the password reset email to
      </Text>
      <Heading css={styles.email} size="xs">
        {email}
      </Heading>
      <Tooltip
        kind="invert"
        triggerRenderer={() => (
          <div css={styles.tooltipContainer}>
            <Icon source={Info} />
            <Text>Didn&apos;t get the email?</Text>
          </div>
        )}
      >
        <Text>
          If you&apos;re logging in using other methods, you can only reset your password through
          your Identity Provider.
        </Text>
      </Tooltip>
    </div>
  </Layout>
);
